const INIT_FILTER_VALUE = {
  address: {
    amphur: null,
    province: null,
    tumbol: null,
    village: null,
  },
  defaultAddress: {
    amphur: null,
    province: null,
    tumbol: null,
  },
};

const state = () => {
  return { ...INIT_FILTER_VALUE };
};

// actions
const actions = {
  clearStore({ commit }) {
    commit("clearStore");
  },
  setStore({ commit }, store) {
    commit("setStore", store);
  },
  setDefaultAddress({ commit }, data) {
    commit("setDefaultAddress", data);
  },
};

// mutations
const mutations = {
  clearStore(state) {
    state = { ...INIT_FILTER_VALUE };
  },
  setStore(state, store) {
    Object.assign(state, store);
  },
  setDefaultAddress(state, data) {
    Object.assign(state.defaultAddress, data);
  },
};

// getters
const getters = {
  province: (state) => state.address.province,
  getAllFilter: (state) => {
    return state;
  },
  getFilterSummary: (state) => {
    let result = [];

    const province = state.address.province || state.defaultAddress.province;
    const amphur = state.address.amphur || state.defaultAddress.amphur;
    const tumbol = state.address.tumbol || state.defaultAddress.tumbol;

    if (province){
      result.push(province.province_name)
    }
    if (amphur){
      result.push(amphur.amphur_name)
    }
    if (tumbol){
      result.push(tumbol.tumbol_name)
    }
    if (state.address.village){
      result.push(state.address.village.village_name)
    }

    return result;
  },
  getFilterForApi: (state, getters, rootState, rootGetters) => {
    const result = {};
    if ((rootGetters["userAuth/getUserProvinceCode"].length === 2 && rootGetters["userAuth/getUserProvinceCode"] !== "00") || state.address.province)
      result.province_ID = state.address.province ? state.address.province._id.province_ID: Number(rootGetters["userAuth/getUserProvinceCode"])
    if (rootGetters["userAuth/getUserAmphurCode"].length === 4 || state.address.amphur)
      result.amphur_ID = state.address.amphur ? state.address.amphur._id.amphur_ID : Number(rootGetters["userAuth/getUserAmphurCode"]);
    if (rootGetters["userAuth/getUserTumbolCode"].length === 6 || state.address.tumbol)
      result.tambol_ID = state.address.tumbol ? state.address.tumbol._id.tumbol_ID : Number(rootGetters["userAuth/getUserTumbolCode"]);
    if (state.address.village)
      result.village_ID = state.address.village._id.village_ID;
    return result;
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
